export const ACTION_ASSET_TYPES = {
  REPORT: 'report',
  DASHBOARD: 'dashboard'
};